// ABOUTME: State management hook for celebration components
// ABOUTME: Coordinates level-ups, achievements, and XP gain indicators

import { useState, useCallback } from 'react'

interface XPGain {
  id: string
  amount: number
}

interface LevelUpState {
  isActive: boolean
  level: number
  xpGained?: number
}

interface AchievementState {
  isActive: boolean
  title: string
  description?: string
}

export function useCelebrations() {
  const [levelUp, setLevelUp] = useState<LevelUpState>({
    isActive: false,
    level: 0,
  })

  const [achievement, setAchievement] = useState<AchievementState>({
    isActive: false,
    title: '',
  })

  const [xpGains, setXpGains] = useState<XPGain[]>([])

  const triggerLevelUp = useCallback((level: number, xpGained?: number) => {
    setLevelUp({ isActive: true, level, xpGained })
  }, [])

  const dismissLevelUp = useCallback(() => {
    setLevelUp((prev) => ({ ...prev, isActive: false }))
  }, [])

  const triggerAchievement = useCallback((title: string, description?: string) => {
    setAchievement({ isActive: true, title, description })
  }, [])

  const dismissAchievement = useCallback(() => {
    setAchievement((prev) => ({ ...prev, isActive: false }))
  }, [])

  const addXPGain = useCallback((amount: number) => {
    const id = crypto.randomUUID()
    setXpGains((prev) => [...prev, { id, amount }])
  }, [])

  const removeXPGain = useCallback((id: string) => {
    setXpGains((prev) => prev.filter((gain) => gain.id !== id))
  }, [])

  return {
    levelUp,
    triggerLevelUp,
    dismissLevelUp,
    achievement,
    triggerAchievement,
    dismissAchievement,
    xpGains,
    addXPGain,
    removeXPGain,
  }
}
